<template>
  <AddAdvertising update />
</template>
<script>
import appConfig from '@/app.config'
import AddAdvertising from '../../../components/dadban/advertising/AddAdvertising.vue'
export default {
  page: {
    title: 'ویرایش فرصت شغلی',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-edit-advertisings',
  components: {
    AddAdvertising,
  },
}
</script>
